// HSE fork: Sites was moved out of Settings and up to the main
// navigation. This is a thin wrapper around the existing `SitesTab`
// component — the tab logic (list on the left, detail on the right,
// selected id encoded in the URL) is unchanged.
//
// URL contract:
//   /sites               → list only, no site focused
//   /sites/:siteId       → focus that site's detail pane
//
// Selecting a site pushes `/sites/:id`; deselecting pushes `/sites`.
// This mirrors what SettingsPage did for `/settings/sites[/:id]`.

import { useNavigate, useParams } from 'react-router-dom'
import { PageShell } from '../../layouts/PageShell'
import { SitesTab } from '../settings/SitesTab'
import { usePermissions } from '../../hooks/usePermissions'

export function SitesPage() {
  const navigate = useNavigate()
  const { siteId } = useParams<{ siteId?: string }>()
  const { can } = usePermissions()

  const canViewSites = can('sites:read')
  if (!canViewSites) {
    return (
      <PageShell title="Sites">
        <div style={{ padding: 24, opacity: 0.7 }}>
          You don't have permission to view sites.
        </div>
      </PageShell>
    )
  }

  return (
    <PageShell title="Sites" scrollContent={false}>
      <SitesTab
        siteId={siteId ?? null}
        onSelectSite={(id) =>
          navigate(id ? `/sites/${id}` : '/sites', { replace: true })
        }
      />
    </PageShell>
  )
}
